export default __webpack_public_path__ + "static/media/rex_osariemen_resume.fc24c956.pdf";